import { render } from "./EnableConformity.vue?vue&type=template&id=288c4626&scoped=true"
import script from "./EnableConformity.vue?vue&type=script&lang=js"
export * from "./EnableConformity.vue?vue&type=script&lang=js"

import "./EnableConformity.vue?vue&type=style&index=0&id=288c4626&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288c4626"]])

export default __exports__